module.exports = __webpack_public_path__ + "static/media/N12.6b0c5d59.jpg";